import Head from 'next/head';
import React from 'react';
import Favicon from 'react-favicon';

function HeadPage({ company }) {
  return (
    <Head>
      <Favicon
        url={
          company?.favicon_filename !== null
            ? company?.favicon_filename
            : '/static/logo_recrutei.png'
        }
      />
      <link
        rel="icon"
        href={
          company?.favicon_filename !== null
            ? company?.favicon_url
            : company?.logo_url !== null
            ? company?.logo_url
            : '/static/logo_recrutei.png'
        }
      />
      <meta charSet="utf-8" />
      <title>{company?.name || 'Recrutei'} - Portal de Vagas</title>
      <meta
        property="og:title"
        content={
          !company?.has_title
            ? `${company?.name} - Veja nossas vagas!`
            : company?.title && company?.title !== ''
            ? company?.title
            : `${company?.name} - Veja nossas vagas!`
        }
      />
      <meta
        property="og:description"
        content={
          !company?.has_subtitle
            ? `Acesse nosso portal e veja nossas vagas disponíveis.`
            : company?.subtitle && company?.subtitle !== ''
            ? company?.subtitle
            : `Acesse nosso portal e veja nossas vagas disponíveis.`
        }
      />
      <meta
        property="og:image"
        content={
          company?.banner_url
            ? `${company?.banner_url}`
            : company?.logo_url
            ? `${company?.logo_url}`
            : 'http://jobs.recrutei.com.br/static/banner.png'
        }
      />
      <meta
        property="twitter:title"
        content={`${company?.name} - Veja nossas Vagas!`}
      />
      <meta
        property="twitter:image"
        content={
          company?.banner_url
            ? `${company?.banner_url}`
            : company?.logo_url
            ? `${company?.logo_url}`
            : 'http://jobs.recrutei.com.br/static/banner.png'
        }
      />
      <meta name="twitter:card" content="summary_large_image" />
      <link
        rel="canonical"
        href={process.env.REACT_APP_URL.concat(`/${company?.label}`)}
      />
    </Head>
  );
}

export default HeadPage;
